/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_LabelInputs */

const en_services_svc_save_label = /** @type {(inputs: Services_Svc_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save time`)
};

const lv_services_svc_save_label = /** @type {(inputs: Services_Svc_Save_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ietaupiet laiku`)
};

/**
* | output |
* | --- |
* | "Save time" |
*
* @param {Services_Svc_Save_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_label = /** @type {((inputs?: Services_Svc_Save_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_label(inputs)
	return en_services_svc_save_label(inputs)
});